import BossModel from "@/models/BossModel";
import GroupPackage from '@/models/Proposal/Group/GroupPackage/GroupPackage'
import Proposal from '@/models/Proposal/Proposal'
import moment from "moment";
import Product from "@/models/Proposal/Product/Product";
import Ticket from "@/models/Proposal/Ticket/Ticket";
import DossierTicket from "@/models/Dossier/Ticket/Ticket";

export default class Group extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/group';

    /**
     *
     * @type {string}
     */
    static entity = 'groups';

    static fields() {
        return {
            id: this.number(null).nullable(),
            proposal_id: this.number(null).nullable(),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
            groupPackage: this.hasOne(GroupPackage, 'proposal_group_id'),
            products: this.hasMany(Product, 'proposal_group_id'),
            tickets: this.hasMany(Ticket, 'proposal_group_id'),
        }
    }

    /**
     *
     * @param proposalId
     */
    static clearByProposal(proposalId) {
        this.all().forEach(group => {
            if (group.proposal_id === proposalId) {

                group.getRelated('products').forEach(product => {
                    product.destroy();
                });
                group.getRelated('tickets').forEach(ticket => {
                    ticket.destroy();
                });

                group.destroy();
            }
        });
    }

    /**
     *
     * @returns {boolean}
     */
    IsPackage() {
        return this.GroupPackage() !== undefined;
    }

    /**
     *
     * @returns {*}
     */
    GroupPackage() {
        return this.getRelated('groupPackage');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Proposal() {
        return this.getRelated('proposal');
    }

    startDate() {
        let dates = [];
        const firstProduct = Product.query().where('proposal_group_id', this.id).orderBy('start_date', 'asc').first();
        if (firstProduct) {
            dates.push(moment(firstProduct.start_date));
        }

        const firstTicket = DossierTicket.query().whereHas('proposalTickets', (query) => {
            query.where('proposal_group_id', this.id);
        }).orderBy('start_date', 'asc').first();
        if (firstTicket) {
            dates.push(moment(firstTicket.start_date));
        }

        dates = dates.filter(n => n);
        return moment.min(dates).format('YYYY-MM-DD');
    }
}
